import React from 'react';
import i18next from 'i18next';
import styled from 'styled-components';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';

const MissingInfoBannerContainer = styled.div`
  background-color: ${themeColors.colorMisingInfoBackgorund};
  padding: ${pxToRem(16)};
  height: ${pxToRem(58)};
  margin-bottom: ${pxToRem(16)};
  ${mediaBelow(variables.breakpoints.bpXl)} {
    padding: ${pxToRemMd(16)};
    min-height: ${pxToRem(120)};
  }
`;

const MissingInfoBannerTypography = styled.p`
  color: ${themeColors.colorMissingInfoText};
  font-weight: 600;
  letter-spacing: 0;

  ${mediaBelow(variables.breakpoints.bpXl)} {
    text-align: center;
  }
`;

const MissingInfoBanner = () => (
  <MissingInfoBannerContainer>
    <MissingInfoBannerTypography>
      {i18next.t('missingInfo.bannerText')}
    </MissingInfoBannerTypography>
  </MissingInfoBannerContainer>
);

MissingInfoBanner.propTypes = {};

export default MissingInfoBanner;
